import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent implements OnInit {
  title = 'ITARIUM Technologies India Pvt. Ltd. | Disclaimer';
  constructor(private titleService: Title,private meta:Meta) { }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.addTags([
      {name: 'keywords', content: 'BMC, BMC Softwares, BMC Tools, Itarium Technologies, IT Support, Technology' },
      {name: 'description', content: 'ITARIUM works with many organizations to provide better IT solutions as per their requirements.'},
      {name: 'robots', content: 'index, follow'}
    ]);
    window.scrollTo(0, 0)
  }

}
